import React, { Component } from "react";

import { ajax_get } from "../network/Ajax";

/**
 * @param fieldName: name des Datenbankfeldes für welches die Organisation benötigt wird z.B. phd_location
 * @param value: Array [organization_id, name der Organisation]
 * @param onSelect: Funktion die Ausgelöst wird sobald der Nutzer ein Suchresultat gewählt hat,
 * @param disabled: Die Komponente kann 'disabled' werden (grau hinterlegtes Formularfeld)
 */
class LocationSearch extends Component {
  constructor(props) {
    super(props);

    this.state = { options: [] };
    this.timer = null;
  }

  search = (event) => {
    var self = this;

    this.props.onSelect(this.props.fieldName, null, event.target.value);

    let success = (result) => {
      self.setState({
        options: JSON.parse(result[0].data) || [],
      });
    };

    clearTimeout(this.timer);

    this.timer = setTimeout(function () {
      var uri =
        "/api/v1/organizations/search?k=name&c=~*&v=" +
        encodeURIComponent(self.props.value[1]) +
        "&limit=10";

      ajax_get(uri, success);
    }, 100);
  };

  select = (event) => {
    var index = event.nativeEvent.target.selectedIndex;
    var organization_id = event.target.value;
    var name = event.nativeEvent.target[index].text;

    this.setState({
      options: [],
    });

    this.props.onSelect(this.props.fieldName, organization_id, name);
  };

  close = () => {
    this.setState({
      options: [],
    });
  };

  render() {
    var self = this;
    var selector = (
      <select className="form-control" size="7" onChange={self.select}>
        <optgroup label="Bitte wählen Sie ein Suchergebnis:">
          {this.state.options.map(function (value, index) {
            return <option value={value.organization_id}>{value.name}</option>;
          })}
        </optgroup>
      </select>
    );

    return (
      <div className="col-xs-9 no-pl has-feedback">
        <input
          value={this.props.value[1]}
          onChange={this.search}
          onClick={this.close}
          autoComplete="off"
          className="form-control"
          placeholder="Location"
          disabled={this.props.disabled}
        />
        {this.props.value[0] ? (
          <span
            className="glyphicon glyphicon-ok form-control-feedback"
            aria-hidden="true"
          ></span>
        ) : null}
        {this.state.options[0] ? selector : null}
      </div>
    );
  }
}

export default LocationSearch;
